<template>


  <header class="clearfix">

      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container">

          <a class="navbar-brand go-top" href="#">
            <img  class="img-fluid" id="logo" style="    max-width: 160px;">
          </a>

          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">

              <template v-for="(item) in data.menu">
                  <li class="nav-item ">
                <a class="nav-link" :href="'#'+item.href+'-section'">{{item.name}}</a>
              </li>

                
              </template>

                 <template v-for="(item) in data.translations">
                  <li class="nav-item ">
               <router-link :to="item.href">{{item.name}}</router-link>
              </li>

                
              </template>

        

                <router-view/>
            </ul>
          </div>
        </div>
      </nav>

    </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    data: Object
  },
  mounted:function(){

    var datos=this.data;
      $( '#logo' ).attr("src",datos.logo_white);
      /*-------------------------------------------------*/
  /* =  preloader function
  /*-------------------------------------------------*/

    var mainDiv = $('#container'),
      preloader = $('.preloader');

    preloader.fadeOut(400, function(){
      mainDiv.delay(400).addClass('active');
    });

      var animateTopButton = $('a.go-top'),
    htmBody = $('html, body');
    
  animateTopButton.on('click', function(event){
    event.preventDefault();
    htmBody.animate({scrollTop: 0}, 'slow');
    return false;
  });

    function getTargetTop(elem){
    
    //gets the id of the section header
    //from the navigation's href e.g. ("#html")
    var id = elem.attr("href");

    //Height of the navigation
    var offset = 78;

    //Gets the distance from the top and 
    //subtracts the height of the nav.
    return $(id).offset().top - offset;
  }


    var elemHref = $('.navbar-nav a.nav-link[href^="#"], a.scroll-btn[href^="#"]');

  elemHref.on('click', function(event) {
    
    //gets the distance from the top of the 
    //section refenced in the href.
    var target = getTargetTop($(this));

    //scrolls to that section.
    $('html, body').animate({scrollTop:target}, 600);

    //prevent the browser from jumping down to section.
    event.preventDefault();
  });


     /* ---------------------------------------------------------------------- */
  /*  Header animate after scroll
  /* ---------------------------------------------------------------------- */

  (function() {

    var docElem = document.documentElement,
      didScroll = false,
      changeHeaderOn = 130;
      document.querySelector( 'header' );
    function init() {
      window.addEventListener( 'scroll', function() {
        if( !didScroll ) {
          didScroll = true;
          setTimeout( scrollPage, 100 );
        }
      }, false );
    }
    
    function scrollPage() {
      var sy = scrollY();
    //  console.log(datos);
      if ( sy >= changeHeaderOn ) {
        $( 'header' ).addClass('active');
      $( '#logo' ).attr("src",datos.logo);
      }
      else {
        $( 'header' ).removeClass('active');
            $( '#logo' ).attr("src",datos.logo_white);
         
      }
      didScroll = false;
    }
    
    function scrollY() {
      return window.pageYOffset || docElem.scrollTop;
    }
    
    init();
    
  })();


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
